import React, { useCallback, useEffect, useState } from 'react'
import SelectAddressForMap from '../SelectAddressForMap'
import './index.less'
import classNames from 'classnames'

type valueType = {
  address: string
  latitude: string | number
  longitude: string | number
  pname?: string
  cityname?: string
  adname?: string
}

interface SelectAddressNoDefaultValueProps {
  value?: valueType
  onChange?: (val?: valueType) => void
  onValueChange?: (val?: valueType) => void
}

export const SelectAddressNoDefaultValue = (props: SelectAddressNoDefaultValueProps) => {
  const [visible, setVisible] = useState(false)
  const [value, setValue] = useState<valueType| undefined>()
  const onChange = useCallback((val) => {
    const newvalue = {
      address: val?.address,
      latitude: val?.pointData?.location?.lat,
      longitude: val?.pointData?.location?.lng,
      pname: val?.pointData?.pname,
      cityname: val?.pointData?.cityname,
      adname: val?.pointData?.adname,
      citycode: val?.pointData?.citycode
    }
    if (props.onChange) {
      props.onChange(newvalue)
    } else {
      setValue(newvalue)
    }
    props.onValueChange?.(newvalue)
    setVisible(false)
  }, [props])
  useEffect(() => {
    setValue(props.value)
  }, [props.value])
  const handleClear = () => {
    if (props.onChange) {
      props.onChange(undefined)
    } else {
      setValue(undefined)
    }
    props.onValueChange?.(undefined)
  }
  return <div className='select-address-no-default-value-container'>
    {visible && <SelectAddressForMap visible={visible} onChange={onChange} onCancel={() => setVisible(false)} />}
    <div className='select-address-no-default-value-btn-wrapper'>
    <div onClick={() => setVisible(true)} className={ classNames('select-address-no-default-value-btn', {'ant-input-placeholder': !value?.address })}>{value?.address || '请选择'}</div>
    <a className='select-address-no-default-value-clear' onClick={handleClear}>清空</a>
    </div>
    
  </div>
}
